import {Injectable} from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class NetmeraService {

  pushEvent(eventObject: any) {
    var netmera = (window as any).netmera;

    netmera.push(function (api) {
      api.sendEvent(eventObject);
    });
  }

  setUser(externalId: string) {
    var netmera = (window as any).netmera;

    netmera.push(function (api) {
      var user = api.getUser();
      user.setCustomId(externalId);
      user.save()
        .then(function () {
          console.log('User saved');
        })
        .catch(function (err) {
          console.log('User save failed. err=' + err);
        });
    });
  }

}




